import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import './TermsOfUseModal.css';
import HtmlRenderer from '../../../../components/HtmlRenderer/HtmlRenderer';

const TermsOfUseModal = ({ isOpen, onClose, onAccept, children, initialChecked }) => {
  const [isChecked, setIsChecked] = useState(initialChecked);

  React.useEffect(() => {
    setIsChecked(initialChecked);
  }, [initialChecked]);

  if (!isOpen) return null;

  const handleAccept = () => {
    if (isChecked) {
      onAccept();
    }
  };

  // Portal: fora do card do formulario, o modal nao herda os estilos dele nem fica dentro do <form>.
  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Termos de Uso</h2>
          <button type="button" className="close-button" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="modal-body">
          <HtmlRenderer htmlString={children} />
        </div>
        <div className="modal-footer">
          <div className="checkbox-container">
            <input
              type="checkbox"
              id="modalTermsAccepted"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
            />
            <label htmlFor="modalTermsAccepted">Li e concordo com os termos de uso</label>
          </div>
          <button type="button" className="close-button-footer" onClick={handleAccept} disabled={!isChecked}>
            Eu aceito os termos acima
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default TermsOfUseModal;
